var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"max-w-[969px] mx-auto"},[(_vm.content)?_c('rich-text-renderer',{attrs:{"document":_vm.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }